import {
  SoccerEventStatusId,
  SoccerIncidentId,
} from '@collector/sportsapi-client-legacy'

import { IncidentsResultConfig } from '../../configuration'

export const incidentsResultConfig: IncidentsResultConfig<SoccerIncidentId> = {
  isResultVisible: (incident) =>
    incident.status_id !== SoccerEventStatusId.PenaltyShootout,
  scoringIncidents: new Map([
    [SoccerIncidentId.Goal, { add: 1, visible: true }],
  ]),
}
